import { defineStore } from 'pinia'
import LocationsService from '../services/Locations';

import type Location from '../classes/Location';

export const useLocationsStore = defineStore({
  id: "locationsStore",
  state: () => ({
    menuLocation: null as (String | null),
    locations: [] as Location[],
  }),
  actions: {
    fetchLocations(): Promise<any> {
      return new Promise((resolve, reject) => {
        LocationsService.getAll().then((resp) => {
          this.locations = resp;
          resolve(resp)
        }).catch((error: Error) => {
          reject(error)
        });
      })
    },
    getLocationById(id: number): Promise<any> {
      return new Promise((resolve, reject) => {
        if(this.locations) {
          let loc = this.locations.find((loc: Location) => {
            return loc.id == id
          });

          if (loc) {
            resolve(loc);
          } else {
            this.fetchLocations().then((resp) => {
              loc = this.locations.find((loc: Location) => {
                return loc.id == id
              });

              resolve(loc);
            })
          }
        } else {
          this.fetchLocations().then((resp) => {
            let loc = this.locations.find((loc: Location) => {
              return loc.id == id
            });

            resolve(loc);
          })
        }
      })
    }
  }
})
